var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollectPercentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.637,
    height: 95.521,
    viewBox: "0 0 95.637 95.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_437",
    x: 15.111,
    y: 50.894,
    width: 30.323,
    height: 36.645,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_438",
    x: 11.782,
    y: 50.167,
    width: 26.687,
    height: 27.762,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_439",
    x: 22.138,
    y: 60.844,
    width: 26.825,
    height: 27.763,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_440",
    x: 0,
    y: 0,
    width: 95.637,
    height: 95.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_441",
    x: 74.607,
    y: 27.224,
    width: 21.027,
    height: 21.028,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_329",
    "data-name": "Groupe 329",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_437-2",
    "data-name": "Trac\\xE9 437",
    d: "M14.324,137.013a1.516,1.516,0,0,0-2.079.529l-9.29,15.616a1.516,1.516,0,0,0,2.606,1.55l9.29-15.616a1.516,1.516,0,0,0-.528-2.079Zm0,0",
    transform: "translate(21.37 -79.91)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_438-2",
    "data-name": "Trac\\xE9 438",
    d: "M-5.04,138.084A4.67,4.67,0,0,0-9.451,133.2c-2.4,0-4.276,2.144-4.276,4.881a4.67,4.67,0,0,0,4.413,4.881c2.4,0,4.275-2.144,4.275-4.881Zm-5.655,0c0-1.037.547-1.849,1.243-1.849.748,0,1.379.847,1.379,1.849,0,1.036-.546,1.848-1.242,1.848-.748,0-1.38-.847-1.38-1.848Zm0,0",
    transform: "translate(34.51 -77.04)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_439-2",
    "data-name": "Trac\\xE9 439",
    d: "M37.5,190.893a4.671,4.671,0,0,0,4.412,4.882,4.906,4.906,0,0,0,0-9.763,4.671,4.671,0,0,0-4.412,4.881Zm5.792,0c0,1-.632,1.849-1.38,1.849s-1.38-.847-1.38-1.849.632-1.849,1.38-1.849,1.38.847,1.38,1.849Zm0,0",
    transform: "translate(-6.36 -119.17)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_328",
    "data-name": "Groupe 328",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_440)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_440-2",
    "data-name": "Trac\\xE9 440",
    d: "M5.09-101.548a1.514,1.514,0,0,0-1.245-.326L-12.7-98.821H-27.217A1.517,1.517,0,0,0-28.733-97.3v.778h-.055a6.925,6.925,0,0,1-5.45-2.631l-1.123-1.414a10.087,10.087,0,0,0-5.836-3.565l2.876-8.807a1.531,1.531,0,0,0-1.441-1.987H-62.719a1.532,1.532,0,0,0-1.434,2.01l4.434,12.886h-3.245a5.028,5.028,0,0,0-5.024,5.023A5,5,0,0,0-66.9-91.894,5.014,5.014,0,0,0-68.759-88a5.029,5.029,0,0,0,2.925,4.563,4.994,4.994,0,0,0-.639,2.45,5.023,5.023,0,0,0,2.211,4.161,4.992,4.992,0,0,0-.891,2.853A5.065,5.065,0,0,0-61.7-69.2L-67.731-63A15,15,0,0,0-72-52.486,15.094,15.094,0,0,0-56.923-37.409h11.4A15.094,15.094,0,0,0-30.45-52.486,15,15,0,0,0-34.719-63l-5.949-6.117a10,10,0,0,0,4.692-2.24l1.146-.982a6.963,6.963,0,0,1,4.53-1.677h1.568v1.192A1.516,1.516,0,0,0-27.216-71.3H4.12a1.517,1.517,0,0,0,1.516-1.516v-6.7A1.516,1.516,0,0,0,4.12-81.041,1.516,1.516,0,0,0,2.6-79.525v5.188H-11.045V-96.043L2.6-98.561v5.721A1.517,1.517,0,0,0,4.12-91.324,1.517,1.517,0,0,0,5.637-92.84v-7.543a1.513,1.513,0,0,0-.546-1.165ZM-41.852-111.9l-2.807,8.592s0,0,0,0l-1.068,3.269H-56.511L-60.593-111.9Zm8.369,59.411A12.058,12.058,0,0,1-45.526-40.441h-11.4A12.058,12.058,0,0,1-68.967-52.486a11.98,11.98,0,0,1,3.41-8.4l7.843-8.065h12.978l7.843,8.065a11.98,11.98,0,0,1,3.41,8.4Zm3.183-24.56a10,10,0,0,0-6.5,2.406l-1.147.983a6.967,6.967,0,0,1-4.53,1.676H-60.13a2.009,2.009,0,0,1-1.99-1.99,1.993,1.993,0,0,1,1.99-1.99,1.516,1.516,0,0,0,1.516-1.516,1.517,1.517,0,0,0-1.516-1.516h-1.32a1.992,1.992,0,0,1-1.99-1.99,1.992,1.992,0,0,1,1.989-1.99,1.516,1.516,0,0,0,1.516-1.516,1.516,1.516,0,0,0-1.516-1.516h-2.285A1.993,1.993,0,0,1-65.726-88a1.992,1.992,0,0,1,1.99-1.99h.77A1.517,1.517,0,0,0-61.449-91.5a1.516,1.516,0,0,0-1.516-1.516,1.994,1.994,0,0,1-1.99-1.99A1.993,1.993,0,0,1-62.964-97h18.337a1.518,1.518,0,0,0,1.442-1.046l1.04-3.186a7.039,7.039,0,0,1,4.41,2.547l1.123,1.414a9.94,9.94,0,0,0,7.825,3.777h.055v16.448Zm4.6,1.516V-95.789h11.623v21.451H-25.7Zm0,0",
    transform: "translate(81 120.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_441-2",
    "data-name": "Trac\\xE9 441",
    d: "M299.37,19.976a1.516,1.516,0,1,0,.585,1.771,1.533,1.533,0,0,0-.585-1.771Zm0,0",
    transform: "translate(-213.41 13.5)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectPercentIcon);
export default __webpack_public_path__ + "static/media/collect-percent-icon.3ba8db34dee79b568917686f398c2207.svg";
export { ForwardRef as ReactComponent };